module.exports = __webpack_public_path__ + "static/img/customize-your-degree-24.913a28e.png";


//////////////////
// WEBPACK FOOTER
// ./static/customize-your-degree-24.png
// module id = Z6vt
// module chunks = 1